// Translation files for multilingual support
export const translations = {
  en: {
    nav: {
      home: 'Home',
      projects: 'Projects',
      about: 'About Us',
      contact: 'Contact'
    },
    seo: {
      home: {
        title: 'Due Mosaic Architects | Innovative Architecture & Design Studio in Luxembourg',
        description: 'High-end architecture studio in Luxembourg delivering innovative design solutions for residential, commercial, and industrial projects. Specializing in contemporary architecture, renovations, and interior design.'
      },
      projects: {
        title: 'Our Projects | Architecture Portfolio | Due Mosaic Architects',
        description: 'Explore our portfolio of innovative architectural designs and completed projects. Residential, commercial, and industrial architecture projects across Luxembourg, Germany, France, and Turkey.'
      },
      about: {
        title: 'About Us | Architecture Studio in Luxembourg | Due Mosaic Architects',
        description: 'Due Mosaic Architects is a high-end architecture studio in Luxembourg delivering innovative design solutions for both small and large-scale projects. Learn about our vision and approach.'
      },
      contact: {
        title: 'Contact Us | Architecture Services in Luxembourg | Due Mosaic Architects',
        description: 'Contact Due Mosaic Architects in Luxembourg. Located at 57 Avenue de la Gare, L-1611 Luxembourg. Professional architecture services for residential and commercial projects.'
      }
    },
    home: {
      servicesTitle: 'Our Services',
      servicesIntro: 'Duemosaicarchitects offers innovative design and construction solutions, combining creativity and precision to bring your projects to life.',
      projectsTitle: 'Our Projects',
      projectsDescription: 'Explore our portfolio of innovative architectural designs and completed projects',
      viewProjects: 'View All Projects'
    },
    services: {
      residential: {
        title: 'Residential',
        description: 'Housing and residential architecture'
      },
      commercial: {
        title: 'Commercial',
        description: 'Offices, libraries, restaurants, co-working spaces'
      },
      renovations: {
        title: 'Renovations',
        description: 'High-quality renovations and transformations'
      },
      interior: {
        title: 'Interior Design',
        description: 'Interior space planning and design'
      },
      restorations: {
        title: 'Restorations',
        description: 'Restorations of buildings and historical monuments'
      },
      survey: {
        title: 'Survey & Planning',
        description: 'Vertical cadastral survey and land-use planning'
      },
      urban: {
        title: 'Urban Development',
        description: 'Neighborhood designing and urban development'
      },
      industrial: {
        title: 'Industrial',
        description: 'Industrial and agricultural constructions'
      },
      educational: {
        title: 'Educational Facilities',
        description: 'School buildings and educational institution architecture'
      }
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      projects: 'Projets',
      about: 'À Propos',
      contact: 'Contact'
    },
    seo: {
      home: {
        title: 'Due Mosaic Architects | Studio d\'Architecture Innovant au Luxembourg',
        description: 'Studio d\'architecture haut de gamme au Luxembourg offrant des solutions de design innovantes pour projets résidentiels, commerciaux et industriels. Spécialisé en architecture contemporaine, rénovations et design d\'intérieur.'
      },
      projects: {
        title: 'Nos Projets | Portfolio d\'Architecture | Due Mosaic Architects',
        description: 'Découvrez notre portfolio de designs architecturaux innovants et projets réalisés. Projets d\'architecture résidentiels, commerciaux et industriels au Luxembourg, Allemagne, France et Turquie.'
      },
      about: {
        title: 'À Propos | Studio d\'Architecture au Luxembourg | Due Mosaic Architects',
        description: 'Due Mosaic Architects est un studio d\'architecture haut de gamme au Luxembourg offrant des solutions de design innovantes pour projets petits et grands. Découvrez notre vision et approche.'
      },
      contact: {
        title: 'Contactez-nous | Services d\'Architecture au Luxembourg | Due Mosaic Architects',
        description: 'Contactez Due Mosaic Architects au Luxembourg. Situé au 57 Avenue de la Gare, L-1611 Luxembourg. Services d\'architecture professionnels pour projets résidentiels et commerciaux.'
      }
    },
    home: {
      servicesTitle: 'Nos Services',
      servicesIntro: 'Duemosaicarchitects offre des solutions innovantes de design et construction, alliant créativité et précision pour donner vie à vos projets.',
      projectsTitle: 'Nos Projets',
      projectsDescription: 'Découvrez notre portfolio de designs architecturaux innovants et projets réalisés',
      viewProjects: 'Voir Tous les Projets'
    },
    services: {
      residential: {
        title: 'Résidentiel',
        description: 'Architecture résidentielle et logements'
      },
      commercial: {
        title: 'Commercial',
        description: 'Bureaux, bibliothèques, restaurants, espaces de coworking'
      },
      renovations: {
        title: 'Rénovations',
        description: 'Rénovations et transformations de haute qualité'
      },
      interior: {
        title: 'Design d\'Intérieur',
        description: 'Planification et design d\'espaces intérieurs'
      },
      restorations: {
        title: 'Restaurations',
        description: 'Restaurations de bâtiments et monuments historiques'
      },
      survey: {
        title: 'Relevé & Planification',
        description: 'Relevé cadastral vertical et planification d\'utilisation des sols'
      },
      urban: {
        title: 'Développement Urbain',
        description: 'Conception de quartiers et développement urbain'
      },
      industrial: {
        title: 'Industriel',
        description: 'Constructions industrielles et agricoles'
      },
      educational: {
        title: 'Établissements Éducatifs',
        description: 'Bâtiments scolaires et architecture d\'institutions éducatives'
      }
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      projects: 'Projekte',
      about: 'Über Uns',
      contact: 'Kontakt'
    },
    seo: {
      home: {
        title: 'Due Mosaic Architects | Innovatives Architektur- und Designstudio in Luxemburg',
        description: 'Hochwertiges Architekturstudio in Luxemburg, das innovative Designlösungen für Wohn-, Gewerbe- und Industrieprojekte liefert. Spezialisiert auf zeitgenössische Architektur, Renovierungen und Innenarchitektur.'
      },
      projects: {
        title: 'Unsere Projekte | Architekturportfolio | Due Mosaic Architects',
        description: 'Entdecken Sie unser Portfolio innovativer Architekturentwürfe und abgeschlossener Projekte. Wohn-, Gewerbe- und Industrie-Architekturprojekte in Luxemburg, Deutschland, Frankreich und der Türkei.'
      },
      about: {
        title: 'Über Uns | Architekturstudio in Luxemburg | Due Mosaic Architects',
        description: 'Due Mosaic Architects ist ein hochwertiges Architekturstudio in Luxemburg, das innovative Designlösungen für kleine und große Projekte liefert. Erfahren Sie mehr über unsere Vision und unseren Ansatz.'
      },
      contact: {
        title: 'Kontaktieren Sie uns | Architekturdienstleistungen in Luxemburg | Due Mosaic Architects',
        description: 'Kontaktieren Sie Due Mosaic Architects in Luxemburg. Standort: 57 Avenue de la Gare, L-1611 Luxemburg. Professionelle Architekturdienstleistungen für Wohn- und Gewerbeprojekte.'
      }
    },
    home: {
      servicesTitle: 'Unsere Dienstleistungen',
      servicesIntro: 'Duemosaicarchitects bietet innovative Design- und Baulösungen, die Kreativität und Präzision kombinieren, um Ihre Projekte zum Leben zu erwecken.',
      projectsTitle: 'Unsere Projekte',
      projectsDescription: 'Entdecken Sie unser Portfolio innovativer Architekturentwürfe und abgeschlossener Projekte',
      viewProjects: 'Alle Projekte Anzeigen'
    },
    services: {
      residential: {
        title: 'Wohnbau',
        description: 'Wohnungs- und Wohnarchitektur'
      },
      commercial: {
        title: 'Gewerbe',
        description: 'Büros, Bibliotheken, Restaurants, Co-Working-Räume'
      },
      renovations: {
        title: 'Renovierungen',
        description: 'Hochwertige Renovierungen und Umgestaltungen'
      },
      interior: {
        title: 'Innenarchitektur',
        description: 'Innenraumplanung und -gestaltung'
      },
      restorations: {
        title: 'Restaurierungen',
        description: 'Restaurierungen von Gebäuden und historischen Denkmälern'
      },
      survey: {
        title: 'Vermessung & Planung',
        description: 'Vertikale Katastervermessung und Flächennutzungsplanung'
      },
      urban: {
        title: 'Stadtentwicklung',
        description: 'Viertelgestaltung und Stadtentwicklung'
      },
      industrial: {
        title: 'Industrie',
        description: 'Industrie- und Landwirtschaftsbauten'
      },
      educational: {
        title: 'Bildungseinrichtungen',
        description: 'Schulgebäude und Architektur von Bildungseinrichtungen'
      }
    }
  },
  lb: {
    nav: {
      home: 'Haaptsäit',
      projects: 'Projeten',
      about: 'Iwwer Eis',
      contact: 'Kontakt'
    },
    seo: {
      home: {
        title: 'Due Mosaic Architects | Innovativt Architektur- a Designstudio zu Lëtzebuerg',
        description: 'Héichwäerteg Architekturstudio zu Lëtzebuerg, dat innovativ Designléisungen fir Wunn-, Handels- an Industrieprojeten ubitt. Spezialiséiert op modern Architektur, Renovatiounen an Interieurdesign.'
      },
      projects: {
        title: 'Eis Projeten | Architekturportfolio | Due Mosaic Architects',
        description: 'Entdeckt eis Portfolio vun innovativen Architekturdesigns a fäerdeg Projeten. Wunn-, Handels- an Industrieprojeten zu Lëtzebuerg, Däitschland, Frankräich a Tierkei.'
      },
      about: {
        title: 'Iwwer Eis | Architekturstudio zu Lëtzebuerg | Due Mosaic Architects',
        description: 'Due Mosaic Architects ass e héichwäerteg Architekturstudio zu Lëtzebuerg, dat innovativ Designléisungen fir kleng a grouss Projeten ubitt. Erfuert méi iwwer eis Visioun an Approche.'
      },
      contact: {
        title: 'Kontaktéiert Eis | Architekturservicer zu Lëtzebuerg | Due Mosaic Architects',
        description: 'Kontaktéiert Due Mosaic Architects zu Lëtzebuerg. Plaz: 57 Avenue de la Gare, L-1611 Lëtzebuerg. Professionell Architekturservicer fir Wunn- a Handelsprojeten.'
      }
    },
    home: {
      servicesTitle: 'Eis Servicer',
      servicesIntro: 'Duemosaicarchitects bitt innovativ Design- a Bauléisungen, déi Kreativitéit a Präzisioun kombinéieren, fir Är Projeten zum Liewen ze bréngen.',
      projectsTitle: 'Eis Projeten',
      projectsDescription: 'Entdeckt eis Portfolio vun innovativen Architekturdesigns a fäerdeg Projeten',
      viewProjects: 'All Projeten Kucken'
    },
    services: {
      residential: {
        title: 'Wunnbau',
        description: 'Wunnungs- a Wunnarchitektur'
      },
      commercial: {
        title: 'Handel',
        description: 'Büros, Bibliothéiken, Restauranten, Co-Working-Raim'
      },
      renovations: {
        title: 'Renovatiounen',
        description: 'Héichwäerteg Renovatiounen a Transformatiounen'
      },
      interior: {
        title: 'Interieurdesign',
        description: 'Interieurraumplanung a -design'
      },
      restorations: {
        title: 'Restauratiounen',
        description: 'Restauratiounen vun Gebaier a historesche Monumenter'
      },
      survey: {
        title: 'Vermessung & Plangung',
        description: 'Vertikal Kadastervermessung a Flächennutzungsplangung'
      },
      urban: {
        title: 'Stadentwécklung',
        description: 'Quartiersgestaltung a Stadentwécklung'
      },
      industrial: {
        title: 'Industrie',
        description: 'Industrie- a Landwirtschaftsbaute'
      },
      educational: {
        title: 'Bildungsinstitutiounen',
        description: 'Schoulgebaier a Architektur vun Bildungsinstitutiounen'
      }
    }
  }
};

